import './styles.scss'
import React from 'react'
import { I18n } from 'react-redux-i18n'
import { Col, Modal, ModalBody, ModalHeader, Row, Badge } from 'reactstrap'
import ReactTooltip from 'react-tooltip'

import { resource } from 'api'
import { MAX_FILE_SIZE, FILE_MAX_SIZE_CONVERSATION } from 'constants/filesMaxSize'
import EmojiSelector from 'components/EmojiSelector'
import UploadFiles from 'components/UploadFiles'
import FilePreview from 'components/UploadFiles/FilePreview'
import DropZoneFileUploader from 'components/common/DropZoneFileUploader'
import HtmlEditor from 'components/HtmlEditor'
import { lang } from 'utils/helpers'
import InputControls from 'components/common/InputControls'
import { Button, ButtonTag } from 'components/Form'
import Nixi1Spinner from 'components/Nixi1Spinner'
const _ = require('lodash')

// eslint-disable-next-line react/display-name
const HtmlEditorSmall = (props) => {
  const {
    id, classNameWrapper, onChange, value, placeholder, company, attachments,
    buttons, removeEmojisAndAccentsValue = false, channel, limit, onPreviewMsg,
    acceptTypes = 'image/*,video/*,application/pdf', currentChannelPreview,
    filesPreview, dropZoneFilesHeight, disableEditor, externalMessage, minHeight,
    forceCleaning, maxHeight, isSmall, isTemplateValue = false, isTemplateCheck,
    editorCssClass, newValue, onClickButton,
    options = [
      "preview",  // BOTON PREVIEW
      "buttons",  // MODAL DE BOTONES
      "emojis",  // EMOJIS
      "attachments",  // ATTACHMENTS
    ]
  } = props

  const quillRef = React.useRef(null)
  const [showEmojis, setShowEmojis] = React.useState(false)
  const [valueEditor, setValueEditor] = React.useState(value)
  const [showModalFiles, setShowModalFiles] = React.useState(false)
  const [uploading, setUploading] = React.useState(false)
  const [attachmentsEditor, setAttachmentsEditor] = React.useState(attachments)
  const [currentCharacters,] = React.useState(0)
  const [counterOverflow,] = React.useState(false)
  const onToggleEmojis = (values) => setShowEmojis(values?.requireToClose ? false : !showEmojis)
  const onToggleModalFiles = () => setShowModalFiles(!showModalFiles)
  const [buttonsEditor, setButtonsEditor] = React.useState(buttons)
  const [removeEmojisAndAccents, setRemoveEmojisAndAccents] = React.useState(removeEmojisAndAccentsValue)
  const [dropZoneIsVisible, setDropZoneIsVisible] = React.useState(false)
  const [filesErrorMessage, setFilesErrorMessage] = React.useState('')
  const [refEditor, setRefEditor] = React.useState(null)
  const [isTemplate, setIsTemplate] = React.useState(isTemplateValue)

  React.useEffect(() => {
    forceCleaning && quillRef.current && quillRef.current.setEditorContents(quillRef.current.editor, '')
  }, [forceCleaning])

  React.useEffect(() => {
    setRemoveEmojisAndAccents(removeEmojisAndAccentsValue)
  }, [removeEmojisAndAccentsValue])

  React.useEffect(() => {
    if (isTemplateValue !== isTemplate) {
      setIsTemplate(isTemplateValue)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isTemplateValue])

  React.useEffect(() => {
    handleOnChange(valueEditor)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [removeEmojisAndAccents, currentChannelPreview, isTemplate])

  React.useEffect(() => {
    if (valueEditor) handleOnChange(valueEditor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttonsEditor])

  React.useEffect(() => {
    //if (valueEditor) handleOnChange(valueEditor)
    setButtonsEditor(buttons)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [buttons])

  React.useEffect(() => {
    setAttachmentsEditor(attachments)
  }, [attachments])

  React.useEffect(() => {
    if (valueEditor !== value) {
      handleOnChange(value)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  React.useEffect(() => {
    handleOnChange(valueEditor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [limit])

  React.useEffect(() => {
    handleOnChange(valueEditor)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [valueEditor])

  const onSelectEmoji = (emoji) => {
    refEditor && refEditor.selection.insertHTML(emoji.native)
    onToggleEmojis()
  }

  const onPasteAttachments = async (attachments) => {
    let _attachments = _.clone(attachments)
    if (attachments?.length > 0 && !attachments[0].shortUrl) {
      _attachments[0].type = `${attachments[0].mimeType}/${attachments[0].mimeSubtype}`
      _attachments[0].name = attachments[0].url
      setAttachmentsEditor(_attachments)
    }

    let contentHtml = _.replace(valueEditor, /&amp;&nbsp;/g, ' ')
    contentHtml = _.replace(contentHtml, /&nbsp;/g, ' ')

    const target = {
      value: '',
      valueHtml: contentHtml,
      attachments: _attachments
    }

    if (showEmojis) onToggleEmojis()
    onChange(target)
    setAttachmentsEditor(_attachments)
  }

  const handleOnChange = (content = '') => {
    let contentHtml = _.replace(content, /&amp;&nbsp;/g, ' ')
    contentHtml = _.replace(contentHtml, /&nbsp;/g, ' ')

    let _attachments = _.clone(attachments?.length > 0 ? attachments : attachmentsEditor)
    if (attachments?.length > 0 && !attachments[0].shortUrl) {
      _attachments[0].type = `${attachments[0].mimeType}/${attachments[0].mimeSubtype}`
      _attachments[0].name = attachments[0].url
      setAttachmentsEditor(_attachments)
    }

    const target = {
      value: '',
      valueHtml: contentHtml,
      attachments: _attachments
    }

    if (showEmojis) onToggleEmojis()
    onChange(target)
  }

  const onUploadFiles = async (files) => {
    setUploading(true)
    let _attachments = []
    try {
      if (files.length > 0) {
        const formData = new FormData()
        const dataBody = {
          companyType: company.type,
          companyToken: company.hash,
          typeUpload: 'userFile',
        }

        formData.append('data', JSON.stringify(dataBody))
        formData.append('files', files[0].file)

        const { data } = await resource.uploadFiles(formData)

        _attachments = [
          {
            _id: false,
            ...data.attachments[0],
            url: data.attachments[0].url,
            urlLong: data.attachments[0].urlLong,
            mimeType: data.attachments[0].mimeType,
            mimeSubtype: data.attachments[0].mimeSubtype,
            fileId: data.attachments[0].fileId,
            type: `${data.attachments[0].mimeType}/${data.attachments[0].mimeSubtype}`,
            name: data.attachments[0].name || data.attachments[0].url,
          }
        ]
      }

      let contentHtml = _.replace(valueEditor, /&amp;&nbsp;/g, ' ')
      contentHtml = _.replace(contentHtml, /&nbsp;/g, ' ')

      const target = {
        value: '',
        valueHtml: contentHtml,
        attachments: _attachments
      }

      if (showEmojis) onToggleEmojis()
      onChange(target)
      setAttachmentsEditor(_attachments)
    } catch (error) {
      console.error(error.message)
    }

    setUploading(false)
  }

  const handleDragEnter = () => setDropZoneIsVisible(true)
  const handleDragLeave = () => setDropZoneIsVisible(false)

  const withAttachments = options.includes('attachments')

  return (
    <div
      className={`small-text-editor-wrapper ${classNameWrapper ? classNameWrapper : ''}`}
      onDragEnter={withAttachments ? handleDragEnter : null}
      onDragLeave={withAttachments ? handleDragLeave : null}
    >
      {dropZoneIsVisible ? (
        <DropZoneFileUploader
          height={dropZoneFilesHeight}
          maxSize={FILE_MAX_SIZE_CONVERSATION}
          uploadFiles={onUploadFiles}
          onError={setFilesErrorMessage}
          onHiddenDropZone={() => setDropZoneIsVisible(false)}
        />
      ): (
        <>
          <div className={`text-editor-back ${disableEditor ? '__disabled' : ''}`}>
            <div
              className='text-editor-wrapper-inner'
              onClick={() => {
                if (disableEditor)
                  externalMessage()
                else
                  return(false)
              }}
            >
              <HtmlEditor
                id={id}
                className={`
                  text-editor-control
                  ${options.find(option => option === 'preview') ? 'previewMsg-control' : ''}
                  ${disableEditor ? 'disable-editor' : ''}
                `}
                defaultValue={value ? value : ''}
                value={newValue || ''}
                placeholder={placeholder}
                withAttachments={withAttachments}
                onPasteAttachments={onPasteAttachments}
                onChange={value => {
                  setValueEditor(value)
                }}
                readonly={disableEditor}
                setInstance={(instance) => setRefEditor(instance)}
                channel={channel}
                minHeight={minHeight}
                maxHeight={maxHeight}
                isSmall={isSmall}
                editorCssClass={editorCssClass}
                isTemplate={isTemplate}
                enter='P'
              />

              <span className={`counter ${counterOverflow && limit ? 'counter-red' : 'counter-normal'}`}>{limit ? `${currentCharacters}/${limit}` : `${currentCharacters}`}</span>

              <div className='upload-files-feedback'>
                {!filesErrorMessage && uploading && <Nixi1Spinner width='25px' height='25px' />}
                {filesErrorMessage && <p className='files-error'>{I18n.t(filesErrorMessage)}</p>}
              </div>
            </div>

            <Row className='d-flex mt-1 pl-3 pr-3'>
              {
                options.includes('preview') && (
                  <Col className='col-md-auto pl-0 pr-0 button-tag-preview'>
                    <ButtonTag onClick={onPreviewMsg} value={I18n.t('dashboard_preview')} />
                  </Col>
                )
              }
              <div className='buttons-icon'>
                {
                  options.includes('emojis') && (
                    <div id={'emojiIconEditorWrapper'} className='text-muted float-right pointer icons' onClick={()=> !disableEditor && onToggleEmojis()}>
                      <img id={'emojiIconEditor'} src={'./img/icons/editor-emoji.svg'} alt='button' />
                    </div>
                  )
                }
                {
                  withAttachments && (
                    <div
                      className='text-muted float-right pointer attachments-wrapper icons'
                      onClick={()=> !disableEditor && onToggleModalFiles()}
                    >
                      {
                        channel === 'facebook_post' ? (
                          <>
                            <img src='./img/icons/editor-image.svg' alt='button' />
                            { attachmentsEditor?.length > 0
                              ?
                              <div className='badge'>
                                <Badge color={'warning'} pill>
                                  {attachmentsEditor?.length}
                                </Badge>
                              </div>
                              :
                              null
                            }
                          </>
                        ) : (
                          <>
                            <img src='./img/icons/editor-file.svg' alt='button' />
                            { attachmentsEditor?.length > 0
                              ?
                              <div className='badge'>
                                <Badge color={'warning'} pill>
                                  {attachmentsEditor?.length}
                                </Badge>
                              </div>
                              :
                              null
                            }
                          </>
                        )
                      }
                    </div>
                  )
                }
                <Button onClick={()=> !disableEditor && onClickButton()} primary value={lang('dashboard_send')} small className='button-send' />
              </div>
            </Row>

            <EmojiSelector showEmojis={showEmojis} handleToggle={onToggleEmojis} handleSelect={onSelectEmoji} />

            <Modal isOpen={showModalFiles} toggle={onToggleModalFiles} centered={true}>
              <ModalHeader>{I18n.t('dashboard_upload-files')}</ModalHeader>
              <ModalBody>
                <UploadFiles
                  uploading={uploading}
                  uploadFiles={onUploadFiles}
                  multiple={false}
                  acceptTypes={acceptTypes}
                  cancel={() => setShowModalFiles(false)}
                  filesUploaded={attachmentsEditor}
                  onRemoveUploadedFile={() => onUploadFiles([])}
                  removeOnDrop={true}
                  maxSize={MAX_FILE_SIZE}
                  messageErrorSize={I18n.t('file-too-big')}
                />
              </ModalBody>
            </Modal>
          </div>

          {filesPreview && attachmentsEditor && attachmentsEditor.length > 0 ? (
            <Row className='mt-1 preview-files'>
              {attachmentsEditor.map((file, key) => (
                <FilePreview
                  key={file.url + key}
                  id={key}
                  url={file.urlLong || file.url}
                  thumb={file.thumb}
                  shortUrl={file.url || file.urlLong}
                  type={file.mime}
                  mimeType={file.mimeType}
                  mimeSubtype={file.mimeSubtype}
                  extension={file.extension}
                  disabled={true}
                />
              ))}
            </Row>
          ) : null}

          {
            channel === 'chatmail' && isTemplateCheck &&
            <>
              <div className='chatmail-check' data-tip={lang('tooltip_chatmail_template_default')}>
                <InputControls
                  type='switch'
                  label={I18n.t('label_chatmail_template_default')}
                  value={isTemplateValue}
                  onChange={value => setIsTemplate(value)}
                />
                <ReactTooltip multiline={true} />
              </div>
            </>
          }
        </>
      )}
    </div>
  )
}
export default HtmlEditorSmall
